import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGroupInfo, IGroupMemberStatistics, ITrainingStatistics } from './types';

export interface IGroupAdminState {
  hasGroup: boolean;
  group?: IGroupInfo;
  memberStats?: {
    [memberId: number]: ITrainingStatistics;
  };
}

export const initialState: IGroupAdminState = {
  hasGroup: false,
};

export const statePropName = 'groupAdmin';

const groupAdminSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initGroup(state, action: PayloadAction<number>) {},
    loadGroup(state) {
      state.group = undefined;
    },
    updateGroup(state, action: PayloadAction<IGroupInfo>) {
      state.hasGroup = true;
      state.group = action.payload;
    },
    loadGroupStats(state) {
      state.memberStats = undefined;
    },
    updateGroupStats(state, action: PayloadAction<IGroupMemberStatistics>) {
      const { memberId, statistics } = action.payload;
      return {
        ...state,
        memberStats: {
          ...state.memberStats,
          [memberId]: statistics,
        },
      };
    },
  },
});

export const GroupAdminActions = groupAdminSlice.actions;
export default groupAdminSlice.reducer;
